export default __webpack_public_path__ + "static/media/gold-template.a6df1e97.png";